import { render, staticRenderFns } from "./approveCooperation.vue?vue&type=template&id=615f230a"
import script from "./approveCooperation.vue?vue&type=script&lang=js"
export * from "./approveCooperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports